export default __webpack_public_path__ + "static/media/banner_2_2_11zon.83652b85.webp";